module.exports = __webpack_public_path__ + "static/media/search.40e0cbc1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/icon/search.svg
// module id = 240
// module chunks = 0